import { useContext } from 'react';
import SectorsContext from "../contexts/SectorsContext";

export const useSectorsContext = () => {
  return useContext(SectorsContext);
};
